import React, { FC } from 'react';
import { TableCellBody, TableRowStyled } from '../styled';
import DeleteTenantCell from './deleteTenantCell';

interface TableProps {
    id: number,
    tenantName: string,
    tenantSurveysCount: number,
    handleDeleteTenant: (tenantId: number, tenantName: string) => void
}

const TableRow: FC<TableProps> = ({ id, tenantName, tenantSurveysCount, handleDeleteTenant }) => (
    <TableRowStyled>
        <TableCellBody>{tenantName}</TableCellBody>
        <TableCellBody>{tenantSurveysCount}</TableCellBody>
        <TableCellBody>
            <DeleteTenantCell
                handleDeleteTenant={handleDeleteTenant}
                tenantId={id}
                tenantName={tenantName}
            />
        </TableCellBody>
    </TableRowStyled>
);

export default TableRow;
